import { Map, Set, List, Record } from 'immutable'
import fetchJSON from 'lib/fetchJSON'
import { fulfilled, pending, rejected } from 'lib/promiseMiddlewareHelpers'
import { deserializeFindResult } from 'lib/api/records'

export const SEARCH_ROUTES = 'routes/SEARCH'

export const SEARCH_MAX = 250 // miles
export const LENGTH_MAX = 500 // miles
export const ELEVATION_MAX = 10000 // feet

export const defaultQuery = Record({
  user_id: null,
  user_type: null,
  trips: 1,
  routes: 1,
  start_location: '',
  start_distance: SEARCH_MAX,
  length_min: 0,
  length_max: LENGTH_MAX,
  elevation_min: 0,
  elevation_max: ELEVATION_MAX,
  keywords: '',
  offset: 0,
  sort_by: ''
})

const includeUnlessFalse = Set(['trips', 'routes'])

const initialState = Map({
  key: defaultQuery(), // all the params
  results: Map(), // query -> List()
  resultsCount: 0
})

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case pending(SEARCH_ROUTES): {
      if (state.get('key') !== action.meta.key) {
        return state.merge({
          key: action.meta.key,
          results: Map(),
          resultsCount: 0
        })
      }
      return state
    }
    case rejected(SEARCH_ROUTES): {
      // TODO: what do I do with this?
      return state
    }
    case fulfilled(SEARCH_ROUTES): {
      if (state.get('key') !== action.meta.key) {
        // We are looking at some out of date results if the queries don't match
        return state
      }

      const records = List(action.payload.results.map(deserializeFindResult))

      const results = state.get('results')
      const resultsKey = action.meta.resultsKey || action.meta.query
      const previousRecords = results.get(resultsKey, Map()).get('records', List())

      const payloadResultsRecord = Record(Object.assign({}, action.meta, {
        results_count: action.payload.results_count,
        records: previousRecords.concat(records)
      }))()

      const resultsWithPayload = results.set(resultsKey, payloadResultsRecord)
      return state.merge({
        results: resultsWithPayload
      })
    }
    default:
      return state
  }
}

// params is a plain js object where each key is a parameter to the search URL, so for a given key 'some_key' it will turn into 'search[some_key]=some_value' in the querystring.
// https://ridewithgps.com/find/search?search[offset]=0&search[user_id]=&search[start_distance]=50&search[start_location]=Portland,+OR,+US&search[keywords]=beach&search[length_min]=0&search[elevation_min]=0&search[elevation_max]=10000&search[sort_by]=
export const search = (query, key, meta) => {
  const defaults = defaultQuery()
  const querystring = query.toMap().filter((value, key) =>
    (includeUnlessFalse.has(key) ? value !== false : defaults.get(key) !== value)
  ).map((value, param) => `search[${param}]=${value}`).join('&')
  return {
    type: SEARCH_ROUTES,
    payload: fetchJSON(`/find/search.json?${querystring}`, {}),
    meta: Object.assign({}, meta, {
      query,
      key
    })
  }
}
